import { lazy, type LazyExoticComponent } from 'react';

import type { ActionKeys } from '@atlassian/conversation-assistant-message-actions-api/constants';
import type { ActionRendererFor } from '@atlassian/conversation-assistant-message-actions-api/types';

export const GoogleDocCreateRendererAsync: LazyExoticComponent<
	(props: ActionRendererFor<typeof ActionKeys.GoogleDocCreate>) => React.JSX.Element
> = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant-message-actions/google-doc-create" */ './GoogleDocCreateAction'
	).then((m) => ({ default: m.GoogleDocCreateAction })),
);
